export const languagesMap: { [key: string]: string } = {
  'Portuguese(Brazil)': '葡萄牙语（巴西）',
  Vietnamese: '越南语',
  'Portuguese(Portugal)': '葡萄牙语（葡萄牙）',
  French: '法语',
  Korean: '韩语',
  'Chinese(Simplified)': '简体中文',
  Dutch: '荷兰语',
  Finnish: '芬兰语',
  Turkish: '土耳其语',
  German: '德语',
  'Spanish(Mexico)': '西班牙语（墨西哥）',
  Thai: '泰语',
  Japanese: '日语',
  'Spanish(Spain)': '西班牙语（西班牙）',
  Italian: '意大利语',
  Hungarian: '匈牙利语',
  English: '英语',
  Czech: '捷克语',
  Danish: '丹麦语',
  Polish: '波兰语',
  'Chinese(Traditional)': '繁体中文',
  Norwegian: '挪威语',
  Swedish: '瑞典语',
  'English(UK)': '英语',
  Hebrew: '希伯来语',
  Russian: '俄语',
  Ukrainian: '乌克兰语',
  Arabic: '阿拉伯语',
};
